import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取job的单证流转
export function fileList(jobUuid) {
  return request({
    url: URL.seaExport.file,
    method: 'get',
    params: { jobUuid }
  })
}

// 单证流转保存
export function saveFile(data) {
  return request({
    url: URL.seaExport.file,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

// 单证流转批量保存
export function updateBatchFile(data) {
  return request({
    url: URL.seaExport.fileBatchUpdate,
    method: 'post',
    data
  })
}

// 删除Job的业务状态
export function delFile(uuid) {
  return request({
    url: URL.seaExport.file + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

/**
 * 判断 文件编号是否存在
 * @param data
 */
export function checkFileNoExist(data) {
  return request({
    url: URL.seaExport.fileCheckFileNoExist,
    method: 'post',
    data
  })
}

/**
 * 文件取回费用结清(更新业务状态)
 * @param data
 */
export function checkChargeWriteoffClear(data) {
  return request({
    url: URL.seaExport.fileCheckChargeWriteoffClear,
    method: 'post',
    data
  })
}

/**
 * 根据公司名称获取十位码
 * @param data
 */
export function getBusinessByCompany(companyCName, fuzzy) {
  return request({
    url: URL.mdm.business.getBusinessByCompany + '?companyCName=' + encodeURIComponent(companyCName) + '&fuzzy=' + encodeURIComponent(fuzzy),
    method: 'get'
  })
}

/**
 * 根据十位码获取十位码
 * @param data
 */
export function getBusinessByTenDigitCode(tenDigitCode) {
  return request({
    url: URL.mdm.business.getBusinessByTenDigitCode + '?tenDigitCode=' + encodeURIComponent(tenDigitCode),
    method: 'get'
  })
}

// 保存或者更新 海关十字码
export function businessCheckSaveUpdate(data) {
  return request({
    url: URL.mdm.business.businessCheckSaveUpdate,
    method: 'post',
    data
  })
}

// 查看报关文件信息
export function findKeyForCustoms(key) {
  return request({
    url: URL.seaExport.findKeyForCustoms + '?key=' + encodeURIComponent(key),
    method: 'get'
  })
}

// 查看报关文件信息
export function getCustomsStatusURL(data) {
  return request({
    url: URL.seaExport.getCustomsStatusURL,
    method: 'post',
    data
  })
}
// 查看报关文件信息
export function getGetCustomsStatusResult(data) {
  return request({
    url: URL.seaExport.getGetCustomsStatusResult,
    method: 'post',
    data
  })
}
// 查询文件数量
export function queryFilesCount(data) {
  return request({
    url: URL.booking.queryFilesCount,
    method: 'get',
    data
  })
}
// ingot文件上传
export function ingotUpload(data, jobKey) {
  return request({
    url: URL.booking.ingotUpload,
    method: 'post',
    data,
    params: { jobKey }
  })
}
// ingot文件上传
export function ingotUploadByJobs(data) {
  return request({
    url: URL.booking.ingotUploadByJobs,
    method: 'post',
    data
  })
}

// ingot日志查询
export function queryIngotUploadList(jobKey) {
  return request({
    url: URL.booking.queryIngotUploadList,
    method: 'get',
    params: { jobKey }
  })
}
// ingot日志查询
export function queryIngotUploadListByJobs(jobKeys) {
  return request({
    url: URL.booking.queryIngotUploadListByJobs,
    method: 'get',
    params: { jobKeys }
  })
}
// 根据originFileId查询file
export function queryFileByOriginFileId(originFileId) {
  return request({
    url: URL.booking.queryFileByOriginFileId,
    method: 'get',
    params: { originFileId }
  })
}
// 根据关单号查询文件
export function queryFileListByCustom(customsInfoKey, documentType) {
  return request({
    url: URL.booking.queryFileListByCustom,
    method: 'get',
    params: { customsInfoKey, documentType }
  })
}
// 删除Job的报关 -批量
export function deleteCustomsInfoFileHandler(data) {
  return request({
    url: URL.booking.deleteCustomsInfoFile,
    method: 'delete',
    data
  })
}

// 单证流转- 查询标记列表
export function queryDcListHandler(data) {
  return request({
    url: URL.booking.queryFilePageableUrl,
    method: 'post',
    data
  })
}

// 单证流转- 取回保存
export function batchBackFileHandler(data) {
  return request({
    url: URL.booking.batchBackFileUrl,
    method: 'post',
    data
  })
}
// 单证流转- 二次送出
export function doSecondSendHandler(data) {
  return request({
    url: URL.booking.secondSendUrl,
    method: 'post',
    data
  })
}

// 单证流转- 修改备注
export function updateRemarkHandler(data) {
  return request({
    url: URL.booking.updateRemarkUrl,
    method: 'post',
    data
  })
}
// 单证流转- 退单管理列表
export function queryHasClearingStateFileHandler(data) {
  return request({
    url: URL.booking.queryHasClearingStateFileHandlerUrl,
    method: 'post',
    data
  })
}
// 单证流转- 退单管理-收款信息
export function getInvoiceByJobHandler(jobUuid) {
  return request({
    url: URL.booking.getInvoiceByJobUrl,
    method: 'get',
    params: { jobUuid }
  })
}
// 单证流转- 退单管理-退单列表
export function getFileByCustomerIdHandler(customerId) {
  return request({
    url: URL.booking.getFileByCustomerIdUrl,
    method: 'get',
    params: { customerId }
  })
}
// 单证流转- 退单管理-撤销退单
export function cancelReturnFileHandler(data) {
  return request({
    url: URL.booking.cancelReturnFileUrl,
    method: 'post',
    data
  })
}
// 单证流转- 批量退还
export function batchReturnFileHandler(data) {
  return request({
    url: URL.booking.batchReturnFileUrl,
    method: 'post',
    data
  })
}
// 单证流转- 批量送出
export function batchSendOutFileHandler(data) {
  return request({
    url: URL.booking.batchSendOutFileUrl,
    method: 'post',
    data
  })
}

export function updateFileFunc(data) {
  return request({
    url: URL.booking.updateCustomsNoUrl,
    method: 'post',
    data
  })
}

export function queryCustomsManageFunc(data, params) {
  return request({
    url: URL.booking.queryCustomsManageUrl,
    method: 'post',
    data,
    params
  })
}

// 查询海出报关文件
export function querySeCustomsFile(data) {
  return request({
    url: URL.booking.querySeCustomsFile,
    method: 'post',
    data
  })
}

export function updateStateFunc(data, params) {
  return request({
    url: URL.booking.updateStateUrl,
    method: 'post',
    data,
    params
  })
}

export function rollbackStateFunc(data, params) {
  return request({
    url: URL.booking.rollbackStateUrl,
    method: 'post',
    data,
    params
  })
}
